import { TpDataObjectText } from './interfaces';

type TpDataObjectTextProps = {
  text: TpDataObjectText;
};

export function DataObjectText(props: TpDataObjectTextProps) {
  return null; // Text is not rendered in the UI as it has no extra properties
}
